import { render, staticRenderFns } from "./regular-order-item.vue?vue&type=template&id=5979713f&"
import script from "./regular-order-item.vue?vue&type=script&lang=js&"
export * from "./regular-order-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports